module.exports = __webpack_public_path__ + "static/media/Gestor-de-vendas.c836fbac.webp";